import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'; // Import Provider from react-redux 
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './Redux/store';
// Import your Redux store 
import { Helmet, HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* Wrap your app with Redux Provider */}
      <PersistGate loading={null} persistor={persistor}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
); reportWebVitals();